import React from "react";

interface CampaignItem {
    title: string;
    description: string;
    images: string[];
}

const CampaignSection: React.FC<CampaignItem> = ({ title, description, images }) => {
    return (
        <div className="mt-10">
            <h2 className="text-white font-euro text-center text-2xl">{title}</h2>
            <p className="text-lightOrange font-euro text-center text-xl">Campaign</p>
            <div className="border-t-2 border-lightOrange my-2 md:mx-14 lg:mx-20"></div>
            <p className="text-white font-frankbook text-center text-lg mb-5">{description}</p>

            <div className="grid md:grid-cols-3 gap-4 items-center">
                {images.map((image, index) => (
                    <img key={index} src={image} alt="Campaign Images" className="w-full h-auto object-contain" />
                ))}
            </div>
        </div>
    );
};

export default CampaignSection;